"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import SafeManagement from "@/views/safemanagements/SafeManagement.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import MainView from "@/components/layout/MainView.vue";
import AccessRules from "@/views/safemanagements/AccessManager/components/AccessRulesController.vue";
import WebResourceRequestList from "@/views/safemanagements/AccessManager/components/WebResourceRequestList.vue";
import _ from "lodash";
import i18n from "@/lang";
const UUID = require("uuid");
import UiMenuBar, {
  MenuController
} from "@/components/menu/ManagerMenuBar.vue";
let AccessManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "access_rule",
          name: i18n.t("safe_management.access_rule"),
          icon_image: "safety_sidebar_6"
        },
        {
          index: "web_resource_request_list",
          name: i18n.t("safe_management.request_list"),
          icon_image: "safety_sidebar_1",
          sub_menus: [
            {
              index: "apply",
              name: i18n.t("safe_management.wait_pass")
            },
            {
              index: "approve",
              name: i18n.t("safe_management.team_pass_sidebar")
            },
            {
              index: "reject",
              name: i18n.t("safe_management.team_refuse_sidebar")
            }
          ]
        }
      ],
      "access_rule",
      ["web_resource_request_list"]
    );
    this.default_components = "";
    this.mumber_autid_key = "";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$session.type === "user") {
        this.default_components = this.$session.permissions.any(
          "ACCESS_CONTROL_SETTING",
          "SHOW_ALL_MENUS"
        ) ? "access_rule" : "apply";
        this.menu_controller = new MenuController(
          false,
          [
            ...(() => {
              if (this.$session.permissions.any(
                "ACCESS_CONTROL_SETTING",
                "SHOW_ALL_MENUS"
              )) {
                return [
                  {
                    index: "access_rule",
                    name: i18n.t("safe_management.access_rule"),
                    icon_image: "safety_sidebar_6"
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              if (this.$session.permissions.any(
                "ACCESS_CONTROL_APPROVAL",
                "SHOW_ALL_MENUS"
              )) {
                return [
                  {
                    index: "web_resource_request_list",
                    name: i18n.t("safe_management.request_list"),
                    icon_image: "safety_sidebar_1",
                    sub_menus: [
                      {
                        index: "apply",
                        name: i18n.t("safe_management.wait_pass")
                      },
                      {
                        index: "approve",
                        name: i18n.t(
                          "safe_management.team_pass_sidebar"
                        )
                      },
                      {
                        index: "reject",
                        name: i18n.t(
                          "safe_management.team_refuse_sidebar"
                        )
                      }
                    ]
                  }
                ];
              } else {
                return [];
              }
            })()
          ],
          this.$session.permissions.any("ACCESS_CONTROL_SETTING", "SHOW_ALL_MENUS") ? "access_rule" : "apply",
          ["web_resource_request_list"]
        );
      } else {
        this.default_components = "access_rule";
      }
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.default_components = _index.index;
        }
      }
    });
  }
  changeCollapse() {
    this.mumber_autid_key = UUID.v4();
  }
  changeTeamComponent(data) {
    console.log(data);
    if (data) {
      this.default_components = data;
    }
  }
};
AccessManager = __decorateClass([
  Component({
    components: {
      SafeManagement,
      MenuItem,
      MainView,
      UiMenuBar,
      AccessRules,
      WebResourceRequestList
    }
  })
], AccessManager);
export {
  AccessManager as default
};
